import { render, staticRenderFns } from "./PasswordRequestView.vue?vue&type=template&id=7a4c5eed&"
import script from "./PasswordRequestView.vue?vue&type=script&lang=js&"
export * from "./PasswordRequestView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports